import { Box, Icon, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

type Props = {
  label: string
  onToggle?: (value: boolean) => void
  active: boolean
  sortable?: boolean
}

export default function Field({ label, onToggle, active, sortable }: Props) {
  if (label === '') {
    return null
  }

  return (
    <Box
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      paddingY="s16"
      paddingLeft="s4"
      paddingRight="s24"
      gap="s12"
    >
      <Box flexDirection="row" gap="s4" alignItems="center" width="full">
        <Box width="s24">{sortable && <Icon.Medium icon="drag-and-drop" />}</Box>
        <Text.Normal ellipsis>{label}</Text.Normal>
        <Box style={{ marginLeft: 'auto ' }}>
          <TogglerCheckbox value={active} onChange={onToggle} disabled={!onToggle} />
        </Box>
      </Box>
    </Box>
  )
}
